import LiveClassRoom from '@cont/CommonOfflineCentres/LiveClassRoom';
import Scholarship from '@cont/CommonOfflineCentres/Scholarship';
import { OFFLINE_VIDEO_TOUR_PLAYED_TOUR_SOURCE_CENTRE_GOAL_PAGE } from '@cont/OfflineCentres/constants';
import WhyUnacademy from '@cont/CommonOfflineCentres/WhyUnacademy';
import ParentsCovered from '@cont/CommonOfflineCentres/ParentsCovered';
import CarouselFeed from './CarouselFeed';
import Acheivers from './Achievers';
import DemoClasses from './DemoClasses';
import Educators from './Educators';
import ImagesList from './ImagesList';
import CentreAddressBlock from './CentreAddressBlock';
import Batches from './Batches';
import TTUBlock from './TTUBlock';
import BatchFooter from './BatchFooter';
import BookAVisitBlock from './BookAVisitBlock';

export const sortCentreData = (data = []) => {
  const newData = data.sort(
    (blockA, blockB) => blockA.webRank - blockB.webRank
  );
  return newData;
};

const LEARNNG_PACKAGE = 'LEARNNG_PACKAGE';
const TTU_BLOCK = 'TTU_BLOCK';
const LIVE_CLASS_OFFERINGS = 'LIVE_CLASS_OFFERINGS';
const EDUCATORS_LIST = 'EDUCATORS_LIST';
const DEMO_CLASSES_LIST = 'DEMO_CLASSES_LIST';
const ACHIEVERS_CARD = 'ACHIEVERS_CARD';
const IMAGES_LIST = 'IMAGES_LIST';
const SCHOLARSHIP = 'SCHOLARSHIP';
const CENTRE_ADDRESS_BLOCK = 'CENTRE_ADDRESS_BLOCK';
const NEW_BATCHES_INFO = 'NEW_BATCHES_INFO';
const OFFLINE_BANNERS = 'OFFLINE_BANNERS';
const WHY_UNACADEMY = 'WHY_UNACADEMY';
const PARENTS_COVERED = 'PARENTS_COVERED';
const STICKY_FOOTER = 'STICKY_FOOTER';
const BOOK_A_VISIT = 'BOOK_A_VISIT';

const keyMapper = {
  learningPackage: LEARNNG_PACKAGE,
  ttuBlock: TTU_BLOCK,
  liveClassOfferings: LIVE_CLASS_OFFERINGS,
  educatorsInfo: EDUCATORS_LIST,
  demoClassesInfo: DEMO_CLASSES_LIST,
  achieversCards: ACHIEVERS_CARD,
  images: IMAGES_LIST,
  scholarship: SCHOLARSHIP,
  centreInfoWeb: CENTRE_ADDRESS_BLOCK,
  newBatchesInfo: NEW_BATCHES_INFO,
  banners: OFFLINE_BANNERS,
  whyUnacademy: WHY_UNACADEMY,
  parentsNeedsCovered: PARENTS_COVERED,
  stickyFooter: STICKY_FOOTER,
  bookAVisitCard: BOOK_A_VISIT
};

const componentMapper = {
  [LIVE_CLASS_OFFERINGS]: LiveClassRoom,
  [EDUCATORS_LIST]: Educators,
  [DEMO_CLASSES_LIST]: DemoClasses,
  [ACHIEVERS_CARD]: Acheivers,
  [IMAGES_LIST]: ImagesList,
  [SCHOLARSHIP]: Scholarship,
  [CENTRE_ADDRESS_BLOCK]: CentreAddressBlock,
  [NEW_BATCHES_INFO]: Batches,
  [TTU_BLOCK]: TTUBlock,
  [OFFLINE_BANNERS]: CarouselFeed,
  [WHY_UNACADEMY]: WhyUnacademy,
  [PARENTS_COVERED]: ParentsCovered,
  [STICKY_FOOTER]: BatchFooter,
  [BOOK_A_VISIT]: BookAVisitBlock
};

export const centreDataProcessor = (data, batchesRef, batchesRefFilterRef) => {
  const sortedData = sortCentreData(data);
  const webBlocksFound = [];
  sortedData.forEach((block) => {
    const Comp = componentMapper[keyMapper[block.name]];
    if (Comp) {
      if (keyMapper[block.name] === keyMapper.banners) {
        webBlocksFound.push(
          <Comp
            data={{ data: block.value }}
            key={block.name}
            batchesRef={batchesRef}
            batchesRefFilterRef={batchesRefFilterRef}
            src={OFFLINE_VIDEO_TOUR_PLAYED_TOUR_SOURCE_CENTRE_GOAL_PAGE}
          />
        );
      } else {
        webBlocksFound.push(
          <Comp
            data={block.value}
            key={block.name}
            batchesRef={batchesRef}
            batchesRefFilterRef={batchesRefFilterRef}
            src={OFFLINE_VIDEO_TOUR_PLAYED_TOUR_SOURCE_CENTRE_GOAL_PAGE}
          />
        );
      }
    }
  });

  return webBlocksFound;
};

export const onScrollHandler =
  (batchesRef, batchesTopRef, setIsBatchesOnTop, batchesRefFilterRef) => () => {
    if (!batchesRef.current || !batchesRefFilterRef.current) return;
    const boundingRect2 = batchesRefFilterRef.current?.getBoundingClientRect();
    const { top } = boundingRect2 || {};
    if (top < 72 && !batchesTopRef.current) {
      setIsBatchesOnTop(true);
      // eslint-disable-next-line  no-param-reassign
      batchesTopRef.current = true;
    } else if (top >= 72 && batchesTopRef.current) {
      setIsBatchesOnTop(false);
      // eslint-disable-next-line  no-param-reassign
      batchesTopRef.current = false;
    }
  };
export const CITY_RADIUS_IN_KM = 10;

// This distance is calculated using the Haversine Formula.
// Refer to this link: http://www.movable-type.co.uk/scripts/latlong.html which covers the details for the same.
const toRadian = (angle) => {
  const radianFactor = Math.PI / 180;
  return angle * radianFactor;
};

export const distance = (start, end) => {
  const { cos } = Math;
  const latitudeDiff = end.lat - start.lat;
  const longitudeDiff = end.long - start.long;
  const inv =
    0.5 -
    cos(toRadian(latitudeDiff)) / 2 +
    (cos(toRadian(start.lat)) *
      cos(toRadian(end.lat)) *
      (1 - cos(toRadian(longitudeDiff)))) /
      2;

  const earthDiameterInKM = 12742; // 2 * R; R = 6371 km

  return earthDiameterInKM * Math.asin(Math.sqrt(inv));
};

export const getPathName = (centreDeepLinkUrl, fallbackRoute) => {
  try {
    const centreCMSUrl = new URL(centreDeepLinkUrl);
    return centreCMSUrl.pathname;
  } catch (error) {
    return fallbackRoute;
  }
};

export const REVERSE_GEOCODE_ERROR =
  'Error occured in getting reverse geocode data';

export const STATUS = { UPCOMING: 'UPCOMING' };
